import { render, staticRenderFns } from "./ModalLoja.vue?vue&type=template&id=3a73139a&scoped=true"
import script from "./ModalLoja.vue?vue&type=script&lang=js"
export * from "./ModalLoja.vue?vue&type=script&lang=js"
import style0 from "./ModalLoja.vue?vue&type=style&index=0&id=3a73139a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a73139a",
  null
  
)

export default component.exports